import { useMutation, gql } from '@apollo/client';
import { useIntl, defineMessages } from 'react-intl';

import toast from 'helpers/toast';

const CREATE_INTEGRATION_ACTION_REQUEST = gql`
  mutation IntegrationActionRequestCreate(
    $input: IntegrationActionRequestCreateInput!
  ) {
    integrationActionRequestCreate(input: $input) {
      success
      errors {
        message
      }
    }
  }
`;

const messages = defineMessages({
  requestSentMsg: {
    id: 'Projects.show.integrationActions.requestSentMsg',
    defaultMessage: 'Request Sent!',
    description: 'Request sent message',
  },
});

const useCreateIntegrationActionRequest = ({
  integrationActionId,
  projectId,
  requestArgs,
}) => {
  const intl = useIntl();

  const [
    createIntegrationActionRequest,
    { loading: isCreateIntegrationActionRequestLoading },
  ] = useMutation(CREATE_INTEGRATION_ACTION_REQUEST, {
    variables: {
      input: {
        integrationActionId,
        projectId,
        requestArgs,
      },
    },
    onCompleted: (data) => {
      const errors = data?.integrationActionRequestCreate?.errors ?? [];
      if (errors.length) {
        toast.error(errors[0].message);
      } else {
        toast.success(intl.formatMessage(messages.requestSentMsg));
      }
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return {
    createIntegrationActionRequest,
    isCreateIntegrationActionRequestLoading,
  };
};

export default useCreateIntegrationActionRequest;
